import { schema } from "normalizr";
export const externalServicesIncident = new schema.Entity("externalServicesIncident");
export const externalServicesIncidentsSchema = new schema.Entity("externalServicesIncidents", {
  externalServicesIncidents: [externalServicesIncident]
}, {
  idAttribute: "service"
});